import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
} from "@angular/core";

@Injectable()
export class DomService {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
  ) {}

  createComponentRef(component: any, params?: any): ComponentRef<any> {
    // Create a component reference from the component
    const componentRef = this.componentFactoryResolver.resolveComponentFactory(component).create(this.injector);

    // Set the needed params to the new component
    if (params) {
      Object.entries(params).forEach((param) => {
        componentRef.instance[param[0]] = param[1];
      });
    }

    // Attach component to the appRef so that it's inside the ng component tree
    this.appRef.attachView(componentRef.hostView);

    return componentRef;
  }

  appendComponentRefToDiv(componentRef: ComponentRef<any>, divSelector: string): void {
    // Get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    // Append DOM element to the div
    const parentDiv = document.querySelector(divSelector);
    if (parentDiv) {
      parentDiv.appendChild(domElem);
    }
  }

  destroyComponent(componentRef: ComponentRef<any>): void {
    // Detach the component from the appRed and destroy the component
    this.appRef.detachView(componentRef.hostView);
    componentRef.destroy();
  }
}
